const WRITER_ROLES = new Set(['owner', 'admin', 'auditor', 'editor']);

export function isUnauthorizedError(error) {
  const signal = `${String(error?.code || '')} ${String(error?.message || '')}`.toLowerCase();
  if (/app[-_ ]?check/.test(signal)) return false;
  if (Number(error?.status) === 403) return true;
  return /forbidden|permission-denied|tenant-access-denied|unauthorized-tenant/.test(signal);
}

/**
 * The API may expose either an explicit capability or the verified membership
 * role alongside the overview. Missing metadata intentionally fails closed.
 */
export function resolveCanManage(overview) {
  const explicit = overview?.access?.canManage
    ?? overview?.permissions?.canManage
    ?? overview?.permissions?.canWrite;
  if (typeof explicit === 'boolean') return explicit;

  const role = String(overview?.access?.role ?? overview?.membership?.role ?? '').toLowerCase();
  return WRITER_ROLES.has(role);
}
